import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { SimpleButton } from '../Buttons';
import { Visible } from '../LayoutComponents';
import { InfoContainerHeaderButtonsProps } from './InfoContainerHeaderButtonsProps';

const testIds = {
  toggle: (prefix: string) => `${prefix}::toggle`,
  editButton: (prefix: string) => `${prefix}::editButton`,
};

export const DefaultHeaderButtons: FC<InfoContainerHeaderButtonsProps> = ({
  controls: {
    isExpandable,
    isExpanded,
    setIsExpanded,
    isEditable,
    isInEditMode,
    setIsInEditMode,
  },
  testIdPrefix,
  ariaLabel,
  inverted,
}) => {
  const { t } = useTranslation();

  const getToggleAriaLabel = () => {
    const action = isExpanded ? t(($) => $.close) : t(($) => $.show);
    return ariaLabel ? `${action} ${ariaLabel.toLocaleLowerCase()}` : action;
  };

  return (
    <div className="flex gap-2">
      <Visible visible={isEditable && !isInEditMode}>
        <SimpleButton
          shape="slim"
          inverted={inverted}
          testId={testIds.editButton(testIdPrefix)}
          onClick={() => {
            setIsInEditMode(true);
            setIsExpanded(true);
          }}
        >
          {t(($) => $.edit)}
        </SimpleButton>
      </Visible>
      <Visible visible={isExpandable && !isInEditMode}>
        <SimpleButton
          shape="slim"
          onClick={() => setIsExpanded((expanded) => !expanded)}
          inverted={inverted ?? !isExpanded}
          testId={testIds.toggle(testIdPrefix)}
          tooltip={getToggleAriaLabel()}
        >
          {isExpanded ? (
            <FaChevronUp
              className={inverted ? 'text-tweaked-brand' : 'text-white'}
              aria-hidden
            />
          ) : (
            <FaChevronDown className="text-tweaked-brand" aria-hidden />
          )}
        </SimpleButton>
      </Visible>
    </div>
  );
};
